<!-- SECTION: Mobile일 때 Floating Drawer
      ====================================================================== -->

<template>
  <v-btn id="floatingIcon2" @click="scrollTop" v-show="visible" fab medium>
    <v-icon id="icon">mdi-arrow-up</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: "FloatingIcon2",
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    drawerChg() {
      this.$parent.$children.map(function (value, key) {
        if (value.$options._componentTag === "AppBar") {
          value.drawer = !value.drawer;
          value.mini = false;
        }
      });
    },
    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 100);
      }, 1);
    },
    scrollListener: function (e) {
      this.visible = window.scrollY > 150;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>
<style lang="scss">
#floatingIcon2 {
  align-self: end;
  bottom: 60px;
  right: 20px;
  color: bisque;
  position: sticky;
  z-index: 2;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #f8f3eb;
}
</style>
